import styled from 'styled-components';
import { Title } from '../Title/Title';
import OwlImage from './assets/OwlImage.png';
import ShieldImage from './assets/ShieldImage.png';
import MobileImage from './assets/MobileImage.png';
import StarImage from './assets/StarImage.png';
import { Paragraph } from '../Paragraph/Paragraph';
import { forwardRef } from 'react';

const items = [
  {
    image: ShieldImage,
    text: 'More than <strong>300,000</strong> people happily  insured',
  },
  {
    image: OwlImage,
    text: '<strong>24/7 support</strong> from the great  OnCampus Abroad team',
  },
  {
    image: StarImage,
    text: 'Over <strong>15 years</strong> of experience',
  },
  {
    image: MobileImage,
    text: '<strong>Quick and easy hire.</strong>  Receive your insurance certificate right after check-out. No waiting around. ',
  },
];

const WhyOCA = forwardRef<HTMLDivElement>((props, ref) => {
  const titleText = 'Why OnCampus';

  return (
    <Background ref={ref}>
      <Title text={titleText} />
      <ItemContainer>
        {items.map((item, index) => (
          <ItemContain key={index}>
            <Image src={item.image} alt={`Icon ${index + 1}`} />
            <ParagraphAlt text={item.text} justification='left' />
          </ItemContain>
        ))}
      </ItemContainer>
    </Background>
  );
});

export default WhyOCA;

const Background = styled.div`
  width: 100%;
  background-color: #05c793;
  border-radius: 47px;
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  scroll-margin-top: 190px;
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  gap: 30px;

  @media (min-width: 768px) {
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
  }

  @media (min-width: 1024px) {
  }
`;

const ParagraphAlt = styled(Paragraph)`
  font-size: 16px;
  line-height: 18px;

  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 25px;
  }
`;

const ItemContain = styled.div`
  border-radius: 13px;
  background-color: #fff6ef;
  padding: 16px;
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    height: 220px;
    width: 270px;
    gap: 12px;
  }

  @media (min-width: 1024px) {
    width: 239px;
    height: 239px;
    gap: 10px;
  }
`;

const Image = styled.img`
  width: 38px;
  height: 38px;

  @media (min-width: 768px) {
    height: 60px;
    width: 60px;
  }
`;
